import * as React from "react";
import { Box, VStack } from "@chakra-ui/react";
import { Select, Search, Tags } from "components";
import { useQueryParams } from "duck";
import { OrganizationStatusEnum } from "requests";

const Filters: React.FC = () => {
  const [params, setParams] = useQueryParams();

  return (
    <VStack alignItems="flex-start" spacing="24px">
      <Search />
      <Box width="240px">
        <Select
          label="Status"
          labelHidden
          isMulti
          placeholder="Status"
          value={params.filter?.status || null}
          controlShouldRenderValue={false}
          onChange={(_, opts) => {
            const newStatuses = opts?.map(opt => opt.value) || null;
            setParams({
              ...params,
              filter: { ...params.filter, status: newStatuses },
              pagination: { page: 1 }
            });
          }}
          options={[
            { value: OrganizationStatusEnum.Active, label: "Active" },
            { value: OrganizationStatusEnum.Archived, label: "Archived" }
          ]}
        />
      </Box>
      <Tags withStatus />
    </VStack>
  );
};

export default Filters;
